export default "__VITE_ASSET__Cys8kG3w__"